import { Instagram as IgIcon, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

const tiles = [
  { src: "/images/ig-d.png", alt: "Crowned lion of TABI Essence of Strength at golden sunset" },
  { src: "/images/ig-c.png", alt: "TABI Legacy eau de parfum bottle with gift box and tiger sticker" },
  { src: "/images/ig-b.png", alt: "TABI fragrance notes — jasmine, rose, bergamot, vanilla and amber in golden swirls" },
  { src: "/images/ig-a.png", alt: "The TABI atelier — a perfumer composing the Essence of Strength" },
];

export default function Instagram() {
  return (
    <section id="instagram" data-testid="instagram-section" className="px-6 py-24 md:px-10 md:py-40">
      <div className="mx-auto max-w-7xl">
        <Reveal className="mb-16 text-center md:mb-24">
          <p data-testid="instagram-eyebrow" className="mb-6 font-mono text-[11px] uppercase tracking-[0.5em] text-gold">
            Instagram
          </p>
          <h2 data-testid="instagram-heading" className="font-serif text-4xl font-light text-neutral-100 sm:text-5xl">
            Follow <em className="text-gold-light">the journey</em>
          </h2>
        </Reveal>

        <a
          href="https://instagram.com/tabi.essenceuk"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="instagram-link"
          className="group block"
        >
          <div className="grid grid-cols-2 gap-1 md:grid-cols-4">
            {tiles.map((t, i) => (
              <Reveal key={t.src} delay={i * 0.08}>
                <div className="relative aspect-square overflow-hidden border border-white/5">
                  <img
                    src={t.src}
                    alt={t.alt}
                    className="h-full w-full object-cover transition-transform duration-[1600ms] ease-out group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-black/30 transition-opacity duration-700 group-hover:opacity-0" />
                </div>
              </Reveal>
            ))}
          </div>

          <div className="mt-10 flex items-center justify-center gap-3 text-neutral-300 transition-colors duration-500 group-hover:text-gold-light">
            <IgIcon className="h-4 w-4" strokeWidth={1.5} />
            <span data-testid="instagram-handle" className="font-mono text-sm tracking-[0.3em]">@tabi.essenceuk</span>
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" strokeWidth={1.5} />
          </div>
        </a>
      </div>
    </section>
  );
}
